export default "__VITE_ASSET__$5C54BCfkQLbGZSsrgZkyg__"